import React from "react";
import { observer } from "mobx-react-lite";
import { Flex } from "@ugc-ui/lego";
import { useStores } from "@client/store";
import { Tile } from "@common/components/Statistic/Tile";
import { TILE } from "@admin/store/campaignStatistic";
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from "recharts";
import { formatDate } from "@common/utils/date";
import { GeneralInfo as DesktopGeneral } from "@common/components/Statistic/GeneralInfo";
import { DefaultTooltip } from "@common/components/Statistic/DefaultTooltip";
import { internationalFormatNum } from "@common/utils/number";

export const CreateCampaignTabStatisticDesktop: React.FC = observer(() => {
  const {
    campaignStatisticStore: {
      pickedTile,
      setTile: handleTileClick,
      totalStatistic,
      chartData,
      startExport: handleExport,
    },
  } = useStores();

  const tiles = Object.keys(totalStatistic).map((key: TILE) => {
    return (
      <Tile
        all={totalStatistic[key].all}
        onClick={handleTileClick}
        isActive={key === pickedTile}
        tile={key}
        key={key}
      />
    );
  });

  return (
    <Flex flexDirection="column" gap={38}>
      <DesktopGeneral
        creationDate={formatDate(new Date())}
        onClickExport={handleExport}
        disabled
      />

      <Flex gap={16}>{tiles}</Flex>

      <Flex>
        <BarChart
          data={chartData}
          width={1000}
          height={300}
          margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" syncWithTicks />
          <XAxis dataKey="date" tick={{ fontFamily: "Roboto, sans-serif" }} />
          <YAxis
            tickFormatter={internationalFormatNum}
            tick={{ fontFamily: "Roboto, sans-serif" }}
          />
          <Bar dataKey="all" fill="rgba(0, 229, 188, 1)" />
          <Tooltip
            cursor={{ fill: "rgba(206, 206, 206, 0.3)" }}
            content={<DefaultTooltip />}
          />
        </BarChart>
      </Flex>
    </Flex>
  );
});
